// extracted by mini-css-extract-plugin
export default {"shiftsTable":"wAgTPTKjUbbvrIccnoYP","rowNumberColumn":"Gcgps_z3CLyEq_4seIZp","actionsColumn":"qJ92dfnVZCCEGb9NA9sJ"};